module.exports = __webpack_public_path__ + "img/FullCover_Chi2.7bb8954d.jpg";